import { render, staticRenderFns } from "./InvoiceDownPaymentGrid.vue?vue&type=template&id=451bd75c"
import script from "./InvoiceDownPaymentGrid.vue?vue&type=script&lang=js"
export * from "./InvoiceDownPaymentGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports